import React, { type ComponentPropsWithoutRef } from 'react';
import { cn } from '@/utils/tailwind.util';
export const StrongText = (props: ComponentPropsWithoutRef<'span'> & {
  text: string;
}) => {
  const {
    className,
    ...rest
  } = props;
  return <span className={cn('text-strong', className)} {...rest} data-sentry-component="StrongText" data-sentry-source-file="StrongText.tsx">
      {props.text}
    </span>;
};